const ActionCompleteConfirmationModal = (props) => {
  const { onClickYes, confirmationText } = props;
  return (
    <>
      <div
        className="modal centered delete-modal fade"
        id="actionCompleteConfirmationModal"
        tabindex="-1"
        aria-labelledby="actionCompleteConfirmationModal"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-body" style={{ height: "unset" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                {confirmationText}
              </p>
            </div>
            <div className="modal-footer">
              <button
                style={{ width: "55px", height: "42px" }}
                type="button"
                className="btn btn-secondary"
                data-bs-toggle="modal"
              >
                No
              </button>
              <button
                type="button"
                className="btn primary-btn ok-btn"
                data-bs-toggle="modal"
                onClick={
                  onClickYes
                }
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActionCompleteConfirmationModal;
